import {createStore, applyMiddleware} from 'redux';
import rootReducer from '../reduces';
import reduxImmutableStateInvariant from 'redux-immutable-state-invariant';
import { composeWithDevTools } from 'redux-devtools-extension';
import thunk from 'redux-thunk';

export default function configureStore(initialState) {
  return createStore(
    rootReducer, 
    initialState,composeWithDevTools(
    applyMiddleware(thunk, reduxImmutableStateInvariant()))
  );
}


/** WEBPACK FOOTER **
 ** ./src/components/store/configureStore.js
 **/